import React from "react";
import { Link } from "react-router-dom";

export const SiteFooter = () => (
  <footer className="border-t border-border py-10" data-testid="site-footer">
    <div className="mx-auto max-w-6xl px-5 sm:px-8">
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <Link to="/" className="flex items-center gap-2">
          <img src="/logo-mark.webp" alt="Send-Proof" className="h-7 w-7 rounded-lg" />
          <span className="font-heading text-base font-bold">Send-Proof</span>
        </Link>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground">
          <Link to="/auth?mode=signin" className="font-semibold text-emerald-400 hover:text-emerald-300" data-testid="footer-signin">Sign in</Link>
          <Link to="/" className="hover:text-foreground" data-testid="footer-home">Home</Link>
          <Link to="/demo" className="hover:text-foreground" data-testid="footer-demo">Live demo</Link>
          <Link to="/pricing" className="hover:text-foreground" data-testid="footer-pricing">Pricing</Link>
          <Link to="/features" className="hover:text-foreground" data-testid="footer-features">Features</Link>
          <Link to="/customers" className="hover:text-foreground" data-testid="footer-customers">Customers</Link>
          <Link to="/vs/send-proof-vs-fieldwire" className="hover:text-foreground" data-testid="footer-vs-fieldwire">vs Fieldwire</Link>
          <Link to="/vs/send-proof-vs-group-texts" className="hover:text-foreground" data-testid="footer-vs-texts">vs Group texts</Link>
          <Link to="/about" className="hover:text-foreground" data-testid="footer-about">About</Link>
          <Link to="/contact" className="hover:text-foreground" data-testid="footer-contact">Contact</Link>
          <a href="mailto:support@send-proof.com" className="hover:text-foreground" data-testid="footer-email">support@send-proof.com</a>
          <Link to="/privacy" className="hover:text-foreground" data-testid="footer-privacy">Privacy</Link>
          <Link to="/terms" className="hover:text-foreground" data-testid="footer-terms">Terms</Link>
        </div>
      </div>
      <div className="mt-6 border-t border-border pt-6 text-center text-xs text-muted-foreground">
        <p>© {new Date().getFullYear()} Arlo Douglas Labs LLC · <Link to="/about" className="hover:text-foreground">About</Link> · <Link to="/contact" className="hover:text-foreground">Contact</Link></p>
      </div>
    </div>
  </footer>
);
